import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import admin from "../../js/admin";
import auth, { _log, messageDialog } from "../../js/auth";
import { I18n } from "react-redux-i18n";
import { playNewAcceptedOrderSound } from "../../js/order-list-util";

class MenuButton extends Component {
  state = {};
  render() {
    const { myStatus } = this.props;
    if (!myStatus || !myStatus.restaurant_settings || (this.props.roles || localStorage.restaurantSelected === "0")) {
      if (!myStatus || !myStatus.restaurant_settings || !admin.hasRole(this.props.roles)) return null;
    }
    var enabledFeature = false;
    const superadmin = myStatus && myStatus.roles && myStatus.roles.filter(r => r.role === "superadmin").length;
    if (this.props.features && myStatus && myStatus.restaurant_settings) {
      this.props.features.forEach(feat => {
        var feature = myStatus.restaurant_settings["enabled-features"]
        feat.split(".").forEach(f => {
          feature = feature[f];
        })
        enabledFeature = enabledFeature || (feature === true || feature?.enabled === true);
      })

    } else {
      enabledFeature = true;
    }
    const style = {
      ...this.props.style,
    };
    if (this.props.backgroundImage) {
      style.backgroundImage = "url('" + this.props.backgroundImage + "')";
    }
    const style2 = {
      width: "100%",
    }
    if (this.props.background) {
      style2.background = this.props.background;
    }
    const iClass = "menuicon " + (!this.props.backgroundImage && this.props.i ? this.props.i : "hidden");
    const diva = (
      <div className={"menuButtonImage " + (this.props.error ? "pulse-infinite" : "") + " " + (this?.props?.className ? this?.props?.className : "")} style={style} onClick={this.props.onClick}>
        <div className="menuButtonBackground" style={style2}>
          {this.props.badge && (
            <span className="menuButtonBadge" style={{ position: "absolute", top: 6, right: 10, color: "#ffd700", fontSize: "1.6em", lineHeight: 1, zIndex: 2, pointerEvents: "none" }}>★</span>
          )}
          <Button variant="none" id={this.props.id} className="menuButton" data-step={this.props["data-step"]} data-intro={this.props["data-intro"]}>
            <i className={iClass}></i>
            <span key={this.props.name}>
              {this.props.children}
              {this.props.name && this.props.name.split(/<br\s*\/?>/gi).map((part, i, arr) => (
                <React.Fragment key={i}>
                  {part}
                  {i < arr.length - 1 && <br />}
                </React.Fragment>
              ))}
            </span>
          </Button>
        </div>
      </div>
    );
    if (this.props.href) {
      if (this.props.href.startsWith("anydesk")) {
        return <div style={{ opacity: enabledFeature ? 1 : .5 }} onClick={this.openExternalLink}>{diva}</div>;
      } else if (this.props.href.startsWith("http")) {
        if (this.props.external && enabledFeature)
          return <div style={{ opacity: enabledFeature ? 1 : .5, width: "100%" }} onClick={this.openExternalLink}>{diva}</div>;
        else
          return <a style={{ opacity: enabledFeature ? 1 : .5 }} href={this.props.href}>{diva}</a>
      } else {
        if ((enabledFeature) || superadmin) {
          if (this.props.external)
            return <div onClick={this.openExternalLink}>{diva}</div>;
          else
            return <Link to={this.props.href} style={{ opacity: enabledFeature ? 1 : .5 }}>{diva}</Link>;
        } else
          return <div onClick={this.featureNotEnabled} style={{ opacity: .5 }}>{diva}</div>;
      }
    } else {
      return diva;
    }
  }

  openExternalLink = () => {
    //eslint-disable-next-line no-undef
    if (cordova.InAppBrowser) {
      _log("Opening external link in system browser: " + this.props.href);
      //eslint-disable-next-line no-undef
      cordova.InAppBrowser.open(this.props.href, '_system', 'hidden=yes,location=no')
    } else {
      _log("Opening external link in new tab: " + this.props.href);
      window.open(this.props.href, '_new');
    }
  }

  featureNotEnabled = () => {
    messageDialog(I18n.t("local.information"), I18n.t("admin_local.you_are_not_authorized_to_access_this_feature"));
  }
}

export default MenuButton;
